import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { openJpKeys, QUERY_KEYS, isValidUUID } from '@restworld/utils-common';
import { useJobPositionsService } from '@restworld/data-services';
import { JobPosition } from '@restworld/utility-types';

function useEmployerJobPositionDetails() {
  const jobPositionId = useRouter().query.id as string;
  const jobPositionService = useJobPositionsService();
  const query = useQuery({
    queryKey: [QUERY_KEYS.JOB_POSITIONS.DETAILS, jobPositionId],
    queryFn: async () => (await jobPositionService.showJobPosition(jobPositionId)).data,
    enabled: !!jobPositionId && isValidUUID(jobPositionId),
  });

  return { jobPositionDetails: query.data, query };
}

export default useEmployerJobPositionDetails;
export const useJobPositionDetails = () => {
  const jobPositionId = useRouter().query.id as string;
  const jobPositionDetails = useQueryClient().getQueryData([
    QUERY_KEYS.JOB_POSITIONS.DETAILS,
    jobPositionId,
  ]) as JobPosition;
  return jobPositionDetails;
};

export const useIsJobOpenFlag = () => {
  const jobPositionDetails = useJobPositionDetails();
  const isOpen = jobPositionDetails?.status_key ? openJpKeys.includes(jobPositionDetails?.status_key) : false;
  return isOpen;
};

export const useDraftState = () => {
  const jobPositionDetails = useJobPositionDetails();
  return jobPositionDetails?.status_key === 'jp_approval';
};

export const useEmployerJobPositionDetailsLoading = () =>
  useQueryClient().getQueryState([QUERY_KEYS.JOB_POSITIONS.DETAILS, useRouter().query.id as string]).status ===
  'pending';
